import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import {
  DefaultLayout,
  PrivateRoute,
  TokenComponent,
} from "@client/shared/components";
import { getUserData } from "@client/utils";

import AccessDenied from "./access-denied";
import Sites from "./Sites";

const App = () => {
  const userData = (getUserData() || {}).user || {};
  const location = useLocation();
  const isRCEmployee = userData.isRCEmployee;
  const appAccess = userData.roleAccess?.appAccess;
  const selectedUserId = sessionStorage.getItem("selectedUserId") || null;
  let drawerList = [
    {
      icon: <img src="/assets/activity-white.svg" alt="Activity" />,
      activeIcon: <img src="/assets/activity-blue.svg" alt="Activity" />,
      to: "/sites",
      label: "Sites",
      tooltipLabel: "Sites",
    },
  ];

  return (
    <DefaultLayout
      drawerList={
        isRCEmployee &&
        (location.pathname === "/sites" ||
          location.pathname === "/sites/")
          ? []
          : drawerList
      }
      isRCEmployee={isRCEmployee}
    >
      <Routes>
        <Route path="/sites" element={<PrivateRoute element={<Sites />} />} />
        <Route path="/token" element={<TokenComponent />} />
        <Route path="/access-denied" element={<AccessDenied open={true} />} />
        <Route path="/" element={<Navigate to={"/sites"} />} />
      </Routes>
    </DefaultLayout>
  );
};

export default App;